import { ACTION_CLICK_BUTTON_ADD_TICKETS_TO_APPLE_WALLET } from 'utils/analytics/eventTypeConstantsAmplitude';
import { MobileTicket } from 'components/business/receipts/MobileTicket/MobileTicket';
import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { isIOS } from 'utils/deviceUtils';
import { stringify } from '@tock/query-string';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

interface Props {
  purchase: core.PastPurchase;
}

export const ReceiptMobileTicket: React.FC<Props> = ({ purchase }) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const location = useLocation();
  const { EXTERNAL_API_BASE } = useSelector((state: StoreType) => state.app.settings);
  const purchaseToken = new URLSearchParams(location.search).get('token');

  if (!purchase.ticketType?.isUsingMobileTicket) {
    return null;
  }

  const appleWalletUrl = `
    ${EXTERNAL_API_BASE}/purchase/${purchase.id}/apple-wallet-pass${
      purchaseToken ? `?${stringify({ token: purchaseToken })}` : ''
    }`;

  const mobileTicketUrl = `
    ${EXTERNAL_API_BASE}/consumer/purchase/mobile-ticket-pdf/${purchase.id}${
      purchase.mobileTicketToken ? `?${stringify({ token: purchase.mobileTicketToken })}` : ''
    }`;

  const handleAddToAppleWallet = () => {
    const { business, ticketType } = purchase;

    amplitudeSendEvent(ACTION_CLICK_BUTTON_ADD_TICKETS_TO_APPLE_WALLET, {
      businessId: business?.id ?? undefined,
      businessName: business?.name ?? undefined,
      experienceVariety: ticketType?.variety ?? undefined,
    });
  };

  return (
    <MobileTicket
      appleWalletUrl={appleWalletUrl}
      mobileTicketUrl={mobileTicketUrl}
      onAddToAppleWallet={handleAddToAppleWallet}
      showAppleWallet={!!isIOS()}
      ticketCount={purchase.ticketCount}
    />
  );
};
